// Shared borders for both MUI TextField (wrapper) and Select (input root).
export const outlinedFieldStyles = {
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e9ecee" },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline, & .Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "black" },
};
